<template>
  <div class="forms">
    <Submitted v-if="submitted" @resetEnquiry="resetEnquiry" />

    <div v-if="!submitted">
      <h1 id="formTitle">Your applications</h1>
      <form @submit="requestToken" v-if="recordNotFound">
        <p>You will need to scan your documents or use your mobile device to take a picture of them.</p>
        <p>Save the scanned or photographed documents as a PDF, JPEG, TIFF or PNG on the device you are using. Each document must be less than 20MB and do not use special characters in the file name.</p>
        <ol class="questions">        
          <li>
            <fieldset>
              <ul class="questions">
                <li>
                  <label for="barcode"> 
                    <span class="label">Reference number</span> 
                    <abbr class="required" title="(required)">*</abbr>
                    <small class="hint">For example, CF123450.</small>
                  </label>
                  <input id="barcode" @change="formatFields()" v-model="barcode" name="barcode" type="text" required="required" maxlength="10" />
                </li>
                <li>
                  <label for="contactPhone"> 
                    <span class="label">Mobile number</span>
                    <abbr class="required" title="(required)">*</abbr>
                    <small class="hint">Must be the mobile number provided when you submitted your application.</small>
                  </label>
                  <input id="contactPhone" @change="formatFields()" v-model="contactPhone" name="contactPhone" type="tel" required="required" maxlength="20" autocomplete="home tel"  />
                </li>
                <li class="section">
                  <fieldset>
                    <ul class="actions">
                        <li>
                          <strong><button :disabled="inProgress" id="requestToken">Request one-time security code</button></strong>
                        </li>
                    </ul>
                  </fieldset>
                </li>
              </ul>
            </fieldset>
          </li>
        </ol>
      </form>
      <div v-if="attempts > 0 && result.total == 0 && !inProgress" class="status warn" id="tokenRequestFailed">Please make sure you have entered the correct details.</div>
      <form v-if="!recordNotFound && !sessionId" @submit="verifyToken">      
        <ol class="questions">        
          <li>
            <fieldset>
              <div class="status info">                
                <p>Your one-time security code will expire 2 minutes.</p>
              </div>
              <ul class="questions">
                <li>
                  <label for="token"> 
                    <span class="label">Enter your one-time security code</span> 
                    <abbr class="required" title="(required)">*</abbr>
                  </label>
                  <input id="token" autofocus="true" ref="token" v-model="token" @change="autoSubmitAtLength()" @keyup="autoSubmitAtLength()" name="token" type="text" required="required" maxlength="6" inputmode="numeric" pattern="[0-9]*" autocomplete="one-time-code" />
                </li>
              </ul>
            </fieldset>
          </li>
          <li>
            <fieldset>
              <ul class="actions compact">
                  <li>
                    <strong><button :disabled="inProgress" id="verifyToken">Verify code</button></strong>
                  </li>
                  <li class="resetItem">
                    <a class="button" @click="resetEnquiry" :disabled="inProgress" id="resendToken">I did not get it</a>
                  </li>
              </ul>
            </fieldset>
          </li>
          <li v-if="tokenNotFound">
            <div class="status warn" id="tokenNotFound">The security code is incorrect or expired.</div>
          </li>
        </ol>
      </form>
      <div v-if="sessionId">
        <form>
          <SessionStatus v-bind:sessionId="sessionId" @submitEnquiry="submitEnquiry" v-bind:submitted="submitted" v-bind:submissionId="submissionId" display="true" fieldsToFilter="barcode_,status_" @resetEnquiry="resetEnquiry" />
          <ul class="actions">
            <li>
              <em><button @click="resetEnquiry">Look up another application</button></em>
            </li>
          </ul>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import sppapi from '@/sppapi.js';
import Submitted from '@/components/session/Submitted.vue'
import SessionStatus from '@/components/session/SessionStatus.vue'

export default {
  name: 'TheSessionRetrieval',
  components: {
    SessionStatus,
    Submitted
  },
  data: function() {
    return {
      inProgress: false,
      barcode: '',
      contactPhone: '',
      sessionId: '',
      submissionId: '',
      recordNotFound: true,
      attempts: 0,
      token: '',
      tokenNotFound: false,
      submitted: false,
      result: { total: 0 }
    }
  },
  mounted: function() {
    const exp = /ref=([A-Z]{2}[0-9]{2,6})/
    const matches = window.location.toString().match(exp)
    if (matches && matches.length == 2) {
      this.barcode = matches[1]
      document.getElementById('contactPhone').focus()
    } else {
      document.getElementById('barcode').focus()
    }
  },
  methods: {
    verifyToken: function(event) {
      if (event) {
        event.preventDefault()
      }
      if (!this.token) {
        return
      }

      this.tokenNotFound = false
      scroll(0, 0);
      sppapi.verifyToken(this, this.token.trim(), this.barcode.trim(), this.contactPhone.trim())
    },
    resetEnquiry: function() {
      this.sessionId = '';
      this.barcode = '';
      this.recordNotFound = true;
      this.contactPhone = '';
      this.attempts = 0;
      this.result.total = 0;
      this.tokenNotFound = false;
      scroll(0, 0);
    },
    autoSubmitAtLength: function(event) {
      if (this.token.length == 6) {
        this.verifyToken(event)
      }
    },
    formatFields: function() {
      if (this.barcode) {
        this.barcode = this.barcode.replaceAll(' ', '').toUpperCase().trim()
      }

      if (this.contactPhone) {
        this.contactPhone = this.contactPhone.replaceAll(' ', '')
        this.contactPhone = this.contactPhone.toUpperCase().trim()
        this.contactPhone = this.contactPhone.replaceAll('+6104', '04')
        this.contactPhone = this.contactPhone.replaceAll('+61', '0')
      }
    },
    submitEnquiry: function(result) {
      this.submitted = result.response == 'OK';
      console.log('Got submitEnquiry in retrieval')
      scroll(0, 0);
    },
    requestToken: function(event) {
      event.preventDefault()
      if (!this.contactPhone) {
        return
      }
      if (!this.barcode) {
        return
      }

      this.sessionId = ''
      this.tokenNotFound = false
      this.token = ''
      scroll(0, 0);
      sppapi.requestToken(this, this.barcode.toUpperCase().trim(), this.contactPhone.trim())
    }
  }
}
</script>